var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSafeToken = function SvgSafeToken(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 402,
    viewBox: "0 0 402 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402 201C402 312.009 312.009 402 201 402C89.9908 402 0 312.009 0 201C0 89.9908 89.9908 0 201 0C312.009 0 402 89.9908 402 201Z",
    fill: "url(#paint0_linear_1137_893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.751 199.479H292.947C284.046 199.479 276.834 206.693 276.834 215.596V258.864C276.834 267.767 269.621 274.982 260.72 274.982H142.151C133.25 274.982 126.037 282.196 126.037 291.099V320.909C126.037 329.813 133.25 337.027 142.151 337.027H267.583C276.484 337.027 283.594 329.813 283.594 320.909V296.992C283.594 288.089 290.807 281.774 299.708 281.774H322.745C331.646 281.774 338.859 274.559 338.859 265.656V215.409C338.859 206.506 331.646 199.479 322.745 199.479H322.751Z",
    fill: "#121312"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.031 140.256C126.031 131.353 133.244 124.139 142.145 124.139H260.641C269.543 124.139 276.755 116.925 276.755 108.021V78.2111C276.755 69.3078 269.543 62.0935 260.641 62.0935H135.276C126.375 62.0935 119.162 69.3078 119.162 78.2111V101.181C119.162 110.084 111.95 117.299 103.048 117.299H80.1139C71.2127 117.299 64 124.513 64 133.416V183.717C64 192.62 71.2428 199.473 80.1441 199.473H109.948C118.849 199.473 126.061 192.258 126.061 183.355L126.031 140.262V140.256Z",
    fill: "#121312"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.406 168.142H216.033C225.363 168.142 232.931 175.719 232.931 185.044V213.678C232.931 223.01 225.357 230.58 216.033 230.58H187.406C178.076 230.58 170.508 223.004 170.508 213.678V185.044C170.508 175.713 178.082 168.142 187.406 168.142V168.142Z",
    fill: "#121312"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1137_893",
    x1: 337.5,
    y1: 44.5,
    x2: 74,
    y2: 359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11FF80"
  })))));
};
export default SvgSafeToken;